export default __webpack_public_path__ + "static/media/Ayanna_Scott_AHV_In_Moms_We_Trust.65a53a22.jpg";